import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getListTournament = (params) => {
    return axios.get(`${backendHost}/api/admin/tournament/list`, {params});
};

export {
    getListTournament
}